export default __webpack_public_path__ + "static/media/Yoanna.a3e970d1.png";